// A payment on a bank without an account (user report 05.11.2026, empty company): instead of stopping, the one step in
// between – Bank, name, IBAN optional – and the same payment goes on (api/client.ts repeats the call). Needs the right
// f_acct EDIT, else the error says what is missing. Own layout from CardStartDialog's elements, nachzudesignen.
import React from 'react';
import { api, errorText, onMissingAccount } from '../../api/client';
import { level, session } from '../../api/auth';
import { loadCore } from '../../data/compta';
import { tr2 } from '../../i18n/lang';

interface State { bank: string | null; holder: string; iban: string; err: string; busy: boolean }

export class BankAccountHost extends React.Component<object, State> {
  state: State = { bank: null, holder: '', iban: '', err: '', busy: false };
  private answer: ((created: boolean) => void) | null = null;
  private ask = (bank: string) => {
    if (level(session.user, 'f_acct') !== 'EDIT' || (bank !== 'BIL' && bank !== 'BGL')) return Promise.resolve(false);
    return new Promise<boolean>((resolve) => { this.answer = resolve; this.setState({ bank, holder: '', iban: '', err: '', busy: false }); });
  };
  private key = (e: KeyboardEvent) => { if (this.state.bank && e.key === 'Escape') this.close(false); };
  componentDidMount() { onMissingAccount(this.ask); window.addEventListener('keydown', this.key); }
  componentWillUnmount() { onMissingAccount(null); window.removeEventListener('keydown', this.key); this.answer?.(false); }
  close(created: boolean) {
    if (this.state.busy) return;
    this.setState({ bank: null }); this.answer?.(created); this.answer = null;
  }

  async save() {
    const S = this.state;
    this.setState({ busy: true, err: '' });
    try {
      await api('/core/bank-accounts', { method: 'POST', body: { bank: S.bank, holder: S.holder.trim() || null, iban: S.iban.trim() || null } });
      await loadCore();
      this.setState({ busy: false }, () => this.close(true));
    } catch (e) { this.setState({ busy: false, err: errorText(e) }); }
  }

  render() {
    const S = this.state;
    if (!S.bank) return null;
    const btn = (primary: boolean): React.CSSProperties => ({ height: 34, padding: '0 14px', borderRadius: 4, border: primary ? 'none' : '1px solid rgba(255,255,255,.16)', background: primary ? '#1375BD' : 'transparent',
      color: '#FBFAFA', font: '600 12.5px/1 Inter,sans-serif', cursor: S.busy ? 'default' : 'pointer', opacity: S.busy ? 0.6 : 1, whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' });
    const field: React.CSSProperties = { height: 38, borderRadius: 4, border: '1px solid rgba(255,255,255,.16)', background: 'rgba(255,255,255,.04)', color: '#FBFAFA', padding: '0 10px', font: '500 13px/1 Inter,sans-serif', outline: 'none' };
    return (
      <div onMouseDown={(e) => e.target === e.currentTarget && this.close(false)} style={{ position: 'fixed', inset: 0, zIndex: 9000, background: 'rgba(10,8,9,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
        <div role="dialog" aria-label={tr2('Konto anlegen', 'Créer le compte')} style={{ width: 420, maxWidth: '100%', borderRadius: 10, background: '#2A2627', border: '1px solid rgba(255,255,255,.1)', boxShadow: '0 24px 60px rgba(0,0,0,.5)', color: '#FBFAFA' }}>
          <div style={{ padding: '18px 22px 10px' }}>
            <div style={{ font: '700 10px/1 Barlow,sans-serif', letterSpacing: '.14em', color: '#9B9698', textTransform: 'uppercase' }}>{tr2('Konto anlegen', 'Créer le compte')}</div>
            <div data-no-tr="1" style={{ font: '800 22px/1.1 Barlow,sans-serif', marginTop: 6 }}>{S.bank}</div>
          </div>
          <div style={{ padding: '0 22px 12px', font: '400 13px/1.5 Inter,sans-serif', color: '#CDD3D9' }}>
            {tr2(`Eine Zahlung wird auf ein Bankkonto gebucht – lege das Konto von ${S.bank} einmal an. Danach geht die Zahlung weiter.`, `Un paiement est enregistré sur un compte bancaire : créez une fois le compte de ${S.bank}. Le paiement continue ensuite.`)}
          </div>
          <form onSubmit={(e) => { e.preventDefault(); void this.save(); }} style={{ padding: '0 22px 18px', display: 'flex', flexDirection: 'column', gap: 10 }}>
            <input autoFocus value={S.holder} onChange={(e) => this.setState({ holder: e.target.value, err: '' })} placeholder={tr2('Kontoinhaber (leer = Firmenname)', 'Titulaire (vide = nom de la société)')} style={field} />
            <input value={S.iban} onChange={(e) => this.setState({ iban: e.target.value.toUpperCase(), err: '' })} placeholder={tr2('IBAN (optional, später unter Firma → Bankkonten)', 'IBAN (facultatif, plus tard sous Entreprise → Comptes bancaires)')} spellCheck={false} style={field} />
            {S.err && <div style={{ font: '500 12px/1.4 Inter,sans-serif', color: '#E57373' }}>{S.err}</div>}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 4 }}>
              <div onClick={() => this.close(false)} style={btn(false)}>{tr2('Abbrechen', 'Annuler')}</div>
              <button type="submit" disabled={S.busy} style={btn(true)}>{tr2('Anlegen und weiter', 'Créer et continuer')}</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
